import commonFun from "@/utils/commonFun";

export default [
    {
        path:'/rfp-manage',
        name: 'rfp-manage',
        component:() => import ('@/components/page/ssr-manage/ssr-manage-search'),
        meta: { title:'nav.rfpManage',type:"rfp" },
    },
    {
        path:'/rfp-manage-add',
        component:() => import ('@/components/page/ssr-manage/ssr-manage-add'),
        name:'rfp-manage-add',
        meta: { title:'common.add',type:"rfp" },
    },
    {
        path:'/rfp-manage-cqs',
        component:() => import ('@/components/page/ssr-manage/ssr-manage-cqs'),
        name:'rfp-manage-detailCqs',
        meta: { title:'rfpManage.rfpCqs',type:"rfp" },
    },
    {
        path:'/rfp-detail-ss',
        component:() => import ('@/components/page/ssr-manage/ssr-detail-ss'),
        name:'rfp-manage-detailSs',
        meta: { title:'common.details',type:"rfp" },
    },
    {
        path:'/rfp-detail-supp',
        component:() => import ('@/components/page/ssr-manage/ssr-detail-supp'),
        name:'rfp-manage-detailSupp',
        meta: { title:'common.details',type:"rfp" },
    },
    {
        path:'/rfp-detail-load',
        component:() => import ('@/components/page/ssr-manage/ssr-detail-load'),
        name:'rfp-manage-detailSupp',
        meta: { title:'common.details',type:"rfp" },
    },
    {
        name: 'rfp-manage-audit',
        path: '/rfp-manage-detailAudit',
        meta: {title: 'common.details',type:"rfp"},
        redirect: to => {
            const {hash, params, query} = to;
            if (commonFun.isSupplier()) {
                return {path: "/rfp-detail-supp", query: {id: query.id}};
            } else {
                return {path: "/rfp-detail-ss", query: {id: query.id}};
            }
        }
    }
]
